
var Model = require("../types/DebouncedModel.js");
var xtend = require("xtend");

var makeRecalculator = Model.makeRecalculator;

module.exports = Model({
	name: "contactspage",
	init: init,
	listeners: listeners,
	triggers: triggers,
	debounce: 100, // Debounce pushes by 50 milliseconds

	_contacts: null,
	_include_urgency: false,
	_has_urgency: false,

	recalculate: recalculate,
	max_pages: max_pages,
});

function listeners() {
	return {
		"atouchawaysettings:updated": handle_settings_updated,
		"availability:updated": makeRecalculator("availability"),
		"contacts:updated": makeRecalculator("contacts"),
		"latestmessages:updated": makeRecalculator("messages"),
		"missed:updated": makeRecalculator("missed"),
		"urgencycontacts:updated": handle_urgency_contacts_updated,
		"callgroups:updated": makeRecalculator("callgroups"),
		"callgroupsmembers:updated": makeRecalculator("callgroupsMembers")
	};
}

function triggers() {
	return {
		"previous": previous_page,
		"next": next_page
	};
}

function init() {
	this._contacts = [];
	this._availability = {};
	this._messages = {};
	this._missed = {};
	this._callgroups = [];

	return this.push({
		rows: 2,
		columns: 3,
		page: 0,
		limit: 0,
		list: [],
		maxpages: 0,
		messaging: 0,
		missed: {},
	});
}

function recalculate() {
	var page = this.data.page;
	var limit = this.data.limit;
	var messaging = this.data.messaging;

	var showingUrgency = this._include_urgency && this._has_urgency;
	var uiButtons = 0;
	if (showingUrgency)
		uiButtons += 1;

	var list = this._callgroups.concat(this._contacts).slice();

	if (limit) {
		var sliceStart = Math.max(page * (limit - uiButtons), 0);
		var sliceEnd = sliceStart + limit - uiButtons;
		list = list.slice(sliceStart, sliceEnd);
	}

	if (showingUrgency) {
		list.unshift({
			listbutton: "urgency"
		});
	}

	var availability = this._availability;
	var messages = this._messages;
	var missed = this._missed;
	var callgroupsMembers = this._callgroupsMembers;

	var populatedList = list.map(function(contact){
		var id = contact._id;
		return xtend(contact, {
			callgroupsMembers: callgroupsMembers,
			isAvailable: availability[id],
			hasMessage: messages[id],
			messaging: messaging,
			missed: missed
		});
	});

	var maxpages = this.max_pages();

	var more = limit && (page < maxpages);
	var less = limit && page;

	var listSize = populatedList.length;
	var rows = 2;
	var columns = 3;

	if (listSize <= 3) {
		rows = 1;
		columns = listSize;
	} else if (listSize === 4) {
		rows = 2;
		columns = 2;
	} else if (listSize <= 6) {
		rows = 2;
		columns = 3;
	} else if (listSize <= 8) {
		rows = 2;
		columns = 4;
	} else {
		columns = 4;
		rows = "scroll";
	}

	if (!limit) {
		rows = "scroll";
		columns = "scroll";
	}

	this.extend({
		hasMore: more,
		hasLess: less,
		rows: rows,
		columns: columns,
		list: populatedList,
		maxpages: maxpages
	});
}

function handle_settings_updated(settings) {
	var limit = settings.pages;
	var messaging = settings.messaging;
	var include_urgency = !settings.legacy;

	if((this.data.limit === limit) && (this._include_urgency === include_urgency) && (this.data.messaging === messaging))
		return;

	this._include_urgency = include_urgency;

	this.extend({
		limit: limit,
		messaging: messaging,
		page: 0
	});

	this.recalculate();
}

function previous_page() {
	if (this.data.limit === 0) return;
	var page = this.data.page - 1;
	if (page >= 0) {
		this.extend({
			page: page
		});
	}
	this.recalculate();

	this.emit("usermetrics:trigger:track", "move to previous page in contacts page");
}

function next_page() {

	var page = this.data.page + 1;

	var limit = this.data.limit;
	if (limit === 0) return;

	if (page <= this.max_pages()) {
		this.extend({
			page: page
		});
	}
	this.recalculate();

	this.emit("usermetrics:trigger:track", "move to next page in contacts page");
}

function max_pages() {
	var showingUrgency = this._include_urgency && this._has_urgency;
	var uiButtons = 0;
	if (showingUrgency)
		uiButtons += 1;

	var limit = this.data.limit;

	if (!limit) return Infinity;

	var contactLength = this._contacts.length;
	var callgroupsLength = this._callgroups.length;

	var length = contactLength + callgroupsLength;
	return Math.ceil(length / (limit - uiButtons)) - 1;
}

function handle_urgency_contacts_updated(contacts) {
	this._has_urgency = contacts.length;
	this.recalculate();
}
